import { Card, Col, Row, Form } from "react-bootstrap";
import { ISiteVisitDetails } from "../../../api/ISiteVisit";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { SiteVisitIcon } from "../../../leap-components/icons/LeapIcons";

interface SiteVisitHeaderProps {
  siteVisit: ISiteVisitDetails;
}

const SiteVisitHeader = ({ siteVisit }: SiteVisitHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <SiteVisitIcon />
                  </td>
                  <td>
                    <h2>Site Visit: {siteVisit.reference}</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={siteVisit.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows label={"Status"} value={siteVisit.status} />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={siteVisit.licence_regno}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SiteVisitHeader;
